import { useIntl } from "react-intl"
import { useRef, useState } from "react"
import { Combobox, CustomTable, CustomTableRef, GetItemsProps, formatDateRange } from "medere-ui-framework"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { classNames } from "primereact/utils"
import CRUHonorariumModal from "./CRUHonorariumModal"
import { NomenclatorDTO, defaultAllNomenclatorDTO } from "../../dto/NomenclatorDTO"
import { ComboDataDTO, defaultAllComboDataDTO } from "../../dto/ComboDataDTO"
import { HonorariumDTO, defaultHonorariumDTO } from "../../dto/HonorariumDTO"
import { useHonorariumService } from "../../servicesHooks/Honorarium/useHonorariumService"
import { useEntityService } from "../../servicesHooks/Entity/useEntityService"

export default function HonorariumView() {
    const { getHonorariums } = useHonorariumService();
    const { getNomenclatorTypes, getNomenclators } = useEntityService();
    const intl = useIntl();
    const [selectedNomenclator, setSelectedNomenclator] = useState<NomenclatorDTO>(defaultAllNomenclatorDTO);
    const [selectedNomenclatorType, setSelectedNomenclatorType] = useState<ComboDataDTO>(defaultAllComboDataDTO);
    const [selectedHonorarium, setSelectedHonorarium] = useState<HonorariumDTO>(defaultHonorariumDTO);
    const [tabIndex, setTabIndex] = useState<number>(1);
    const [openCreateHonorariumWindow, setOpenCreateHonorariumWindow] = useState<boolean>(false);
    const queryRef = useRef<CustomTableRef>(null);

  return (
    <div className='px-4 flex flex-column honorarium-view-container viewContainer'>
        <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">
        <h2 className="text-2xl mainTitle">
            {intl.formatMessage({ id: 'HonorariumByPractice' })}
        </h2>
        </div>
        <div className="flex justify-content-between">
            <ul className="surface-card p-0 m-0 list-none flex overflow-x-auto select-none">
                <li style={{backgroundColor:'#f9fafb'}}>
                    <a className={classNames('p-ripple cursor-pointer px-4 py-3 flex align-items-center border-bottom-2 hover:border-500 transition-colors transition-duration-150    border-noround', { 'tabComponent': tabIndex == 1, 'text-700 border-transparent': tabIndex != 1 })} onClick={() => setTabIndex(1)}>
                        <span className="font-medium" style={{color:(tabIndex == 1)?'#01717C':'#1C2E4599'}}>{intl.formatMessage({id:'Actives'})}</span>
                    </a>
                </li>
                <li style={{backgroundColor:'#f9fafb'}}>
                    <a className={classNames('p-ripple cursor-pointer px-4 py-3 flex align-items-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 border-noround', { 'tabComponent': tabIndex == 2, ' text-700 border-transparent': tabIndex != 2 })} onClick={() => setTabIndex(2)}>
                        <span className="font-medium" style={{color:(tabIndex == 2)?'#01717C':'#1C2E4599'}}>{intl.formatMessage({id:'Upcoming'})}</span>
                    </a>
                </li>
                <li style={{backgroundColor:'#f9fafb'}}>
                    <a className={classNames('p-ripple cursor-pointer px-4 py-3 flex align-items-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 border-noround', { 'tabComponent': tabIndex == 3, 'text-700 border-transparent': tabIndex != 3 })} onClick={() => setTabIndex(3)}>
                        <span className="font-medium" style={{color:(tabIndex == 3)?'#01717C':'#1C2E4599'}}>{intl.formatMessage({id:'Inactive'})}</span>
                    </a>
                </li>
            </ul>
            <Button className="button" style={{color:'#01717C', background:'#193B670D',fontFamily: 'Inter',fontSize: '14px', border: 'none',fontWeight: 500, lineHeight: '17px', letterSpacing: '0em', textAlign: 'center'}} label={intl.formatMessage({id:'CreateHonorarium'})} onClick={()=>{
                setSelectedHonorarium(defaultHonorariumDTO);
                setOpenCreateHonorariumWindow(true);
            }}/>
        </div>
        <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">
            <Combobox 
                label={intl.formatMessage({id:'PracticeType'})} 
                getItems={(getItemProps:GetItemsProps)=> {
                    return getNomenclatorTypes(getItemProps).then((res:any)=>{
                        return [defaultAllComboDataDTO,...res];
                    })    
                }} 
                optionLabel='name' 
                setValue={(e:ComboDataDTO) => {
                    setSelectedNomenclatorType(e);
                }} 
                value={selectedNomenclatorType}
                placeholder={intl.formatMessage({id:'<All>'})} 
            />
            <Combobox 
                label={intl.formatMessage({id:'Practice'})} 
                getItems={(getItemProps:GetItemsProps)=> {
                    return getNomenclators(getItemProps).then((res:any)=>{
                        return [defaultAllNomenclatorDTO,...res];
                    })    
                }}
                params={{nomenclatorTypes:[selectedNomenclatorType.id]}} 
                optionLabel='codeanddescription' 
                setValue={(e:NomenclatorDTO) => {
                    if(e){
                        if (e.nomenclatortypedesc !== undefined && e.nomenclatortype !== undefined) {
                            setSelectedNomenclatorType({name:e.nomenclatortypedesc,id:e.nomenclatortype});
                        }
                        setSelectedNomenclator(e);
                    }
                }} 
                value={selectedNomenclator} 
                reLoadItemsValue={selectedNomenclatorType} 
                placeholder={intl.formatMessage({id:'<All>'})} 
            />
        </div>
        <CustomTable idTable="tableHonorariums" getItems={getHonorariums} params={{
                nomenclatorType: selectedNomenclatorType,
                nomenclator: selectedNomenclator,
                active: tabIndex
            }} className='crudTable editable-cells-table' minItemWidth filterRow={false} hideFiltersButton ref={queryRef}>
            <Column field="nomenclatortypedesc" header={intl.formatMessage({id:'PracticeType'})} className="text-left" body={(h:HonorariumDTO) => <div className=' text-left'>{h.nomenclatortypedesc}</div>} />
            
            <Column field="nomenclatorcode" header={intl.formatMessage({id:'Code'})} className="text-center"/>
            
            <Column field="nomenclatordesc" header={intl.formatMessage({id:'Description'})} className=""  body={(h:HonorariumDTO) => <div className=' text-left'>{h.nomenclatordesc}</div>} />
            
            <Column field="value" header={intl.formatMessage({ id: 'Amount' })} className="text-right"
                body={(rowData) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>$</span>
                            <span style={{ textAlign: 'right' }}>
                                {rowData.value?rowData.value.toLocaleString('es-AR', {
                                    maximumFractionDigits: 0,
                                    style: 'decimal'
                                }):'0'}
                            </span>
                        </div>
                    );
                }}
            />
            
            <Column field="billingbyhour" header={intl.formatMessage({id:'TypeOfPayment'})} className="text-left" body={(honorarium:HonorariumDTO)=>{
                return (<div className=' text-left'>{honorarium.billingbyhour?intl.formatMessage({id:'ByHour'}):intl.formatMessage({id:'ByAttention'})}</div>);
            }}
            style={{ textAlign: 'center' }}
            />
            <Column field="daterange" header={intl.formatMessage({id:'Validity'})} className="text-center"
            body={(honorarium) => {
                return formatDateRange(honorarium.datestart,honorarium.dateend,intl.formatMessage({id:'NoLimit'}))
            }}/>
            <Column header={intl.formatMessage({id:'Edit'})} className="text-center"
                body={(honorarium:HonorariumDTO) => (
                    <Button
                        icon={"pi pi-file-edit"}
                        className="p-button-rounded p-button-success p-button-outlined tableButton"
                        onClick={() => {
                            setSelectedHonorarium(honorarium);
                            setOpenCreateHonorariumWindow(true);
                        }}
                    />
                )}
                style={{ textAlign: 'center' }}
            />
        </CustomTable>
        <CRUHonorariumModal openCreateHonorariumWindow={openCreateHonorariumWindow} setOpenCreateHonorariumWindow={setOpenCreateHonorariumWindow} honorariumToEdit={selectedHonorarium} updateHonorariumTableFunction={queryRef.current?.refreshTable}></CRUHonorariumModal>
    </div>
  )
}
